import * as yup from 'yup';

import validateSubscriptionEmail from './validateSubscriptionEmail';

const schema = () =>
  yup.object().shape({
    email: validateSubscriptionEmail(),
  });

export default schema;
